import React, {useEffect, useState} from 'react';
import {Head, Title, Wrapper} from '../../styles/pages/pages';
import {useDispatch, useSelector} from 'react-redux';
import Loading from '../../components/Loading/Loading';
import {
  AccountContent,
  AccountDetails,
  AccountInput,
  AccountText,
  AccountTitle,
  Block,
  Row,
  SelectorWrapper,
  TheSaveButton,
} from '../AccountPage/AccountPage.style';
import {
  Container,
  LoadingWrapper,
  PostCodeErrorMsg,
} from './CompleteProfile.Style';
import {DropdownStandard} from '../../styles/components/dropdown';
import {REGISTER_SECTOR_AND_SUBCATEGORIES} from '../../constants/constants';
import {Checkbox} from '../../components/Marketing/Checkbox';
import {addressLookup, postcodeLookup} from '../../actions/lookup.action';
import {completeProfile as doCompleteProfile} from '../../actions/completeProfile.action';
import {ExtraWrapper} from '../../styles/components/wrapper';
import {Button} from '../../styles/components/form';
import {useHistory} from 'react-router-dom';
import {SUCCESS_REGISTER_PATH} from '../../constants/routePaths';
import {Link} from '../../components/LoginRegister/LoginRegister.style';
import {
  PRIVACY_POLICY_LINK,
  TERMS_AND_CONDITIONS_LINK,
} from '../../constants/links';
import MarketingOptions from '../../components/Marketing/MarketingOptions';
import {getMarketingOptions} from '../../actions';

const CompleteProfile = ({match}) => {
  const {accounts, lookup, completeProfile} = useSelector(state => ({
    accounts: state.accounts,
    lookup: state.lookup,
    completeProfile: state.completeProfile,
  }));

  const [accountType, setAccountType] = useState('2');
  const [ageConfirmation, setAgeConfirmation] = useState(false);
  const [businessName, setBusinessName] = useState('');
  const [businessCategorySelect, setBusinessCategorySelect] = useState('');
  const [businessCustomerType, setBusinessCustomerType] = useState('');
  const [showSubcategory, setShowSubcategory] = useState(false);
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);
  const [postalCode, setPostalCode] = useState('');
  const [streetAddress, setStreetAddress] = useState('');
  const [addressListValue, setAddressListValue] = useState('');
  const [invalidAddress, setInvalidAddress] = useState(false);
  const [whereDidYouHearAboutUs, setWhereDidYouHearAboutUs] = useState('');
  const [subscribeToMarketing, setSubscribeToMarketing] = useState(false);
  const [
    termsAndConditionsAndPrivacyPolicyAccept,
    setTermsAndConditionsAndPrivacyPolicyAccept,
  ] = useState(false);
  const [city, setCity] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();

  const profileError = completeProfile && completeProfile.error;
  const profileData = completeProfile && completeProfile.data;

  const renderLoading = !profileData && <Loading isLight={false} />;
  const renderTitle = !profileData ? 'Validating...' : 'Complete Your Profile';
  const isSubmitting = completeProfile && completeProfile.loading;

  const handleAgeConfirmation = () => {
    setAgeConfirmation(!ageConfirmation);
  };

  const handleInvalidAddress = () => {
    setInvalidAddress(!invalidAddress);
  };

  const handleSubscribeToMarketing = () => {
    setSubscribeToMarketing(!subscribeToMarketing);
  };

  const handleTermsAndConditionsAndPrivacyPolicyAccept = () => {
    setTermsAndConditionsAndPrivacyPolicyAccept(
      !termsAndConditionsAndPrivacyPolicyAccept
    );
  };

  const handleForm = () => {
    dispatch(
      doCompleteProfile({
        email: profileData.email,
        name: profileData.name,
        readOnlyEmail: profileData.email,
        postalCode,
        streetAddress,
        city,
        accountType,
        businessName,
        subscribeToMarketing,
        businessCustomerType,
        ageConfirmation,
        termsAndConditionsAndPrivacyPolicyAccept,
        invalidAddress,
        latitude,
        longitude,
        whereDidYouHearAboutUs,
      })
    );
  };

  useEffect(() => {
    if (!businessCategorySelect) {
      setShowSubcategory(false);
      setBusinessCustomerType('');
      setSubcategoryOptions([]);
      return;
    }
    const selected = REGISTER_SECTOR_AND_SUBCATEGORIES[businessCategorySelect];
    if (Array.isArray(selected)) {
      setShowSubcategory(true);
      setSubcategoryOptions(selected);
      setBusinessCustomerType('');
    } else if (typeof selected === 'string') {
      setShowSubcategory(false);
      setBusinessCustomerType(selected);
      setSubcategoryOptions([]);
    } else {
      setShowSubcategory(false);
      setBusinessCustomerType('');
      setSubcategoryOptions([]);
    }
  }, [businessCategorySelect]);

  useEffect(() => {
    if (
      completeProfile &&
      !completeProfile.loading &&
      completeProfile &&
      completeProfile.successRegister
    ) {
      window.location.href = SUCCESS_REGISTER_PATH;
    }
  }, [completeProfile]);

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      history.push('/');
    }
  }, [accounts]);

  const handlePostcodeLookup = () => {
    if (postalCode) dispatch(postcodeLookup(postalCode));
  };

  const handleAddressSelect = e => {
    const udprn = e.target.value;
    setAddressListValue(udprn);
    if (udprn) dispatch(addressLookup(udprn));
  };

  useEffect(() => {
    setError(null);
    if (lookup && lookup.address) {
      setStreetAddress(lookup.streetAddress);
      setCity(lookup.address.post_town);
      setLatitude(lookup.address.latitude);
      setLongitude(lookup.address.longitude);
      setPostalCode(lookup.address.postcode);
    }
    if (lookup && lookup.postcode && lookup.postcode.length === 0) {
      setError('Postcode not found!');
    }
  }, [lookup]);

  const renderForm = profileData && (
    <AccountContent>
      <Block>
        <Row>
          <AccountTitle>Account Name</AccountTitle>
          <AccountDetails>
            <AccountText>
              {profileData.name} {profileData.email && `(${profileData.email})`}
            </AccountText>
          </AccountDetails>
        </Row>
        <Row>
          <AccountTitle>Account Type</AccountTitle>
          <AccountDetails>
            <SelectorWrapper>
              <DropdownStandard
                value={accountType}
                onChange={e => setAccountType(e.target.value)}
                disabled={isSubmitting}
              >
                <option value={2}>Business</option>
                <option value={1}>Personal</option>
              </DropdownStandard>
            </SelectorWrapper>
          </AccountDetails>
        </Row>
        <Row>
          <AccountDetails>
            <Checkbox
              onClick={handleAgeConfirmation}
              text="I confirm that I am over 18"
              enabled={ageConfirmation}
              disabled={isSubmitting}
            />
          </AccountDetails>
          {profileError && profileError.ageConfirmation && (
            <PostCodeErrorMsg>
              {profileError && profileError.ageConfirmation}
            </PostCodeErrorMsg>
          )}
        </Row>
      </Block>

      {ageConfirmation && (
        <Block>
          {ageConfirmation && accountType === '2' && (
            <>
              <Row $isError={profileError && !!profileError.businessName}>
                <AccountTitle>Business Name</AccountTitle>
                <AccountDetails>
                  <AccountInput
                    id="businessName"
                    type="text"
                    placeholder="Enter your business name"
                    value={businessName}
                    onChange={e => setBusinessName(e.target.value)}
                    disabled={isSubmitting}
                  />
                </AccountDetails>
                {profileError && profileError.businessName && (
                  <PostCodeErrorMsg>
                    {profileError && profileError.businessName}
                  </PostCodeErrorMsg>
                )}
              </Row>
              <Row>
                <AccountTitle>Business Category</AccountTitle>
                <AccountDetails>
                  <DropdownStandard
                    id="businessCategorySelect"
                    aria-label="Business Category"
                    value={businessCategorySelect}
                    onChange={e => setBusinessCategorySelect(e.target.value)}
                    tabIndex={0}
                    disabled={isSubmitting}
                  >
                    <option disabled value="">
                      Select Category
                    </option>
                    {Object.keys(REGISTER_SECTOR_AND_SUBCATEGORIES).map(key => (
                      <option key={key} value={key}>
                        {key}
                      </option>
                    ))}
                  </DropdownStandard>
                </AccountDetails>
              </Row>
              {showSubcategory && (
                <Row
                  $isError={profileError && !!profileError.businessCustomerType}
                >
                  <AccountTitle>Business Subcategory</AccountTitle>
                  <AccountDetails>
                    <DropdownStandard
                      id="businessCustomerType"
                      aria-label="Business Subcategory"
                      value={businessCustomerType}
                      onChange={e => setBusinessCustomerType(e.target.value)}
                      tabIndex={0}
                      disabled={isSubmitting}
                    >
                      <option disabled value="">
                        Select Subcategory
                      </option>
                      {subcategoryOptions.map(sub => (
                        <option key={sub.id} value={sub.id}>
                          {sub.name}
                        </option>
                      ))}
                    </DropdownStandard>
                  </AccountDetails>
                  {profileError && profileError.businessCustomerType && (
                    <PostCodeErrorMsg>
                      {profileError && profileError.businessCustomerType}
                    </PostCodeErrorMsg>
                  )}
                </Row>
              )}
            </>
          )}
          <Row $isError={profileError && !!profileError.postalCode}>
            <AccountTitle>Postcode</AccountTitle>
            <AccountDetails>
              <AccountInput
                id="postalCode"
                type="text"
                placeholder="Enter your Postcode"
                value={postalCode}
                onChange={e => setPostalCode(e.target.value)}
                disabled={isSubmitting}
              />
              <TheSaveButton onClick={handlePostcodeLookup}>
                Look Up
              </TheSaveButton>
              <PostCodeErrorMsg>{error}</PostCodeErrorMsg>
            </AccountDetails>
            {profileError && profileError.streetAddress && (
              <PostCodeErrorMsg>
                {profileError && profileError.streetAddress}
              </PostCodeErrorMsg>
            )}
          </Row>
          {lookup &&
            Array.isArray(lookup.postcode) &&
            lookup.postcode.length > 0 && (
              <Row>
                <AccountTitle>Address</AccountTitle>
                <AccountDetails>
                  <DropdownStandard
                    id="addressList"
                    value={addressListValue}
                    onChange={handleAddressSelect}
                    className="w-full border rounded px-2 py-1"
                    aria-label="Select Address"
                    tabIndex={0}
                    disabled={isSubmitting}
                  >
                    <option value="">Please select your address</option>
                    {lookup.postcode &&
                      lookup.postcode.map(addr => (
                        <option
                          key={addr && addr.udprn ? addr.udprn : ''}
                          value={addr && addr.udprn ? addr.udprn : ''}
                        >
                          {addr && addr.suggestion ? addr.suggestion : ''}
                        </option>
                      ))}
                  </DropdownStandard>
                </AccountDetails>
              </Row>
            )}
          <Row>
            <AccountTitle>Invalid address</AccountTitle>
            <AccountDetails>
              <Checkbox
                onClick={handleInvalidAddress}
                text="If this address is not quite right, tick this box and we will contact you"
                enabled={invalidAddress}
                disabled={isSubmitting}
              />
            </AccountDetails>
          </Row>
          <Row>
            <AccountTitle>Where did you hear about us?</AccountTitle>
            <AccountDetails>
              <DropdownStandard
                value={whereDidYouHearAboutUs}
                onChange={e => setWhereDidYouHearAboutUs(e.target.value)}
                disabled={isSubmitting}
              >
                <option disabled value="">
                  Where did you hear about us?
                </option>
                <option value="Google search">Google search</option>
                <option value="Word of mouth">Word of mouth</option>
                <option value="Facebook">Facebook</option>
                <option value="Instagram">Instagram</option>
                <option value="Twitter">Twitter</option>
                <option value="Linkedin">Linkedin</option>
                <option value="Press &amp; media">Press &amp; media</option>
                <option value="Sales representative">
                  Sales representative
                </option>
                <option value="Printed marketing">Printed marketing</option>
                <option value="Event or exhibition">Event or exhibition</option>
                <option value="JJ Blog">JJ Blog</option>
                <option value="TikTok">TikTok</option>
                <option value="YouTube">YouTube</option>
              </DropdownStandard>
            </AccountDetails>
            {profileError && profileError.whereDidYouHearAboutUs && (
              <PostCodeErrorMsg>
                {profileError && profileError.whereDidYouHearAboutUs}
              </PostCodeErrorMsg>
            )}
          </Row>
          <Row>
            <AccountDetails>
              <Checkbox
                onClick={handleSubscribeToMarketing}
                text="I would like to have special offers emailed to me"
                enabled={subscribeToMarketing}
                disabled={isSubmitting}
              />
            </AccountDetails>
          </Row>
          <Row>
            <AccountDetails>
              <Checkbox
                onClick={handleTermsAndConditionsAndPrivacyPolicyAccept}
                text={
                  <span>
                    I agree to the I agree to the JJ Foodservice{' '}
                    <Link href={TERMS_AND_CONDITIONS_LINK.url} target="_blank">
                      {TERMS_AND_CONDITIONS_LINK.content}
                    </Link>{' '}
                    and{' '}
                    <Link href={PRIVACY_POLICY_LINK.url} target="_blank">
                      {PRIVACY_POLICY_LINK.content}
                    </Link>
                  </span>
                }
                enabled={termsAndConditionsAndPrivacyPolicyAccept}
                disabled={isSubmitting}
              />
            </AccountDetails>
            {profileError &&
              profileError.termsAndConditionsAndPrivacyPolicyAccept && (
                <PostCodeErrorMsg>
                  {profileError &&
                    profileError.termsAndConditionsAndPrivacyPolicyAccept}
                </PostCodeErrorMsg>
              )}
          </Row>
          {profileError && profileError.general && (
            <Row $isError>
              <PostCodeErrorMsg>
                {profileError && profileError.general}
              </PostCodeErrorMsg>
            </Row>
          )}
        </Block>
      )}
    </AccountContent>
  );
  const renderFormSubmittingLoading = isSubmitting && (
    <Loading isLight={false} />
  );
  const renderButton = profileData && (
    <ExtraWrapper>
      <LoadingWrapper>{renderFormSubmittingLoading}</LoadingWrapper>
      <Button onClick={handleForm}>Complete Profile</Button>
    </ExtraWrapper>
  );
  return (
    <Wrapper>
      <Head>
        <Title>{renderTitle}</Title>
      </Head>
      <Container>
        {renderLoading}
        {renderForm}
        {renderButton}
      </Container>
    </Wrapper>
  );
};
export default CompleteProfile;
